import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { DeviceEventType, IDeviceEvent } from '../api';
import { TranslationKey } from '../shared';

@Injectable({
    providedIn: 'root'
  })

export class AlarmTypeTranslationService {
    constructor(private transSvc: TranslocoService) {
    }
    translateDeviceEventType(type: DeviceEventType): string {
        const translationKey = this.getDeviceEventTypeTranslationKey(type);
        if (!translationKey) {
            return '' + type;
        }
        return this.transSvc.translate(translationKey);
    }
    private getDeviceEventTypeTranslationKey(type: DeviceEventType): string {
        if (type === DeviceEventType.evtNever) {
            return TranslationKey.never;
        } else if (type === DeviceEventType.evtAlways) {
            return TranslationKey.always;
        } else if (type === DeviceEventType.evtOnEnteringSleepMode) {
            return TranslationKey.onEnteringSleep;
        } else if (type === DeviceEventType.evtOnLeavingSleepMode) {
            return TranslationKey.onLeaveSleep;
        } else if (type === DeviceEventType.evtOnMotion) {
            return TranslationKey.onMotion;
        } else if (type === DeviceEventType.evtOnStandStill) {
            return TranslationKey.onStandStill;
        } else if (type === DeviceEventType.evtOnLoggerUsedStorageLimitExceeded) {
            return TranslationKey.loggerUsedStorageLimitExceeded;
        } else if (type === DeviceEventType.evtOnEnteringGeoZone) {
            return TranslationKey.enteringGeoZone;
        } else if (type === DeviceEventType.evtOnLeavingGeoZone) {
            return TranslationKey.leavingGeoZone;
        } else if (type === DeviceEventType.evtOnEnteringGSMGeoZone) {
            return TranslationKey.enteringGSMGeoZone;
        } else if (type === DeviceEventType.evtOnLeavingGSMGeoZone) {
            return TranslationKey.leavingGSMGeoZone;
        } else if (type === DeviceEventType.evtOnMobileNetworkAttach) {
            return TranslationKey.onMobileNwAttach;
        } else if (type === DeviceEventType.evtOnMobileNetworkDetach) {
            return TranslationKey.evtOnMobileNetworkDetach;
        } else if (type === DeviceEventType.evtOnDigitalInputOn) {
            return TranslationKey.digitalInputOn;
        } else if (type === DeviceEventType.evtOnDigitalInputOff) {
            return TranslationKey.digitalInputOff;
        } else if (type === DeviceEventType.evtOnDigitalInputChange) {
            return TranslationKey.digitalInputChange;
        } else if (type === DeviceEventType.evtOnMultipleDigitalInputsOn) {
            return TranslationKey.multipleDigitalInputOn;
        } else if (type === DeviceEventType.evtOnMultipleDigitalInputsOff) {
            return TranslationKey.multipleDigitalInputOff;
        } else if (type === DeviceEventType.evtOnMultipleDigitalInputsChange) {
            return TranslationKey.multipleDigitalInputChange;
        } else if (type === DeviceEventType.evtOnAnalogInputChange) {
            return TranslationKey.analogInputChange;
        } else if (type === DeviceEventType.evtOnEnteringTimeRange) {
            return TranslationKey.enteringTimeRange;
        } else if (type === DeviceEventType.evtOnLeavingTimeRange) {
            return TranslationKey.leavingTimeRange;
        } else if (type === DeviceEventType.evtOnIPConnection) {
            return TranslationKey.onIPConnection;
        } else if (type === DeviceEventType.evtOnIPDisconnection) {
            return TranslationKey.onIPDisconnection;
        } else if (type === DeviceEventType.evtOnCSDConnection) {
            return TranslationKey.onCSDConnection;
        } else if (type === DeviceEventType.evtOnCSDDisconnection) {
            return TranslationKey.onCSDDisconnection;
        } else if (type === DeviceEventType.evtOnPowerConsumptionMoreThanTriggerLevel) {
            return TranslationKey.powerConsumptionMoreThanTriggerLevel;
        } else if (type === DeviceEventType.evtOnSpeedMoreThanTriggerLevel) {
            return TranslationKey.speedMoreThanTriggerLevel;
        } else if (type === DeviceEventType.evtOnSpeedLessThanTriggerLevel) {
            return TranslationKey.speedLessThanTriggerLevel;
        } else if (type === DeviceEventType.evtOnGPSReceivingQualityChange) {
            return TranslationKey.gpsReceivingQualityChange;
        } else if (type === DeviceEventType.evtOnTimer) {
            return TranslationKey.timer;
        } else if (type === DeviceEventType.evtOnRealTime) {
            return TranslationKey.realTime;
        } else if (type === DeviceEventType.evtOnVoxActive) {
            return TranslationKey.OnVoxActive;
        } else if (type === DeviceEventType.evtOnVoxPassive) {
            return TranslationKey.onVoxPassive;
        } else if (type === DeviceEventType.evtOnTemperatureMoreThanTriggerLevel) {
            return TranslationKey.temperatureMoreThanTriggerLevel;
        } else if (type === DeviceEventType.evtOnTemperatureLessThanTriggerLevel) {
            return TranslationKey.temperatureLessThanTriggerLevel;
        } else if (type === DeviceEventType.evtOnPowerUp) {
            return TranslationKey.onPowerUp;
        } else if (type === DeviceEventType.evtOnAudioConnection) {
            return TranslationKey.onAudioConnection;
        } else if (type === DeviceEventType.evtOnAudioDisconnection) {
            return TranslationKey.onAudioDisconnection;
        } else if (type === DeviceEventType.evtAnyEvent) {
            return TranslationKey.anyEvent;
        }
        return '';
    }
}
